import http from './request'

export const globalConfig_api = () => {
    return http({
        method: "get",
        url: "/api/system/info"
    })
}


// 获取图片验证码
export const getCode_api = data => {
    return http({
        method: "post",
        url: '/api/oauth/captcha',
        data
    })
}

//登陆
export const login_api = data => {
    return http({
        method: "post",
        url: '/api/oauth/token',
        data
    })
}

//获取考场/考点信息
export const place_info_api = data => {
    return http({
        method: "post",
        url: '/api/account/place_info',
        data
    })
}


//获取考试计划列表
export const plan_api = data => {
    return http({
        method: "post",
        url: '/api/plan/list',
        data
    })
}


//获取等待开考时信息
export const waitInfo_api = data => {
    return http({
        method: "post",
        url: '/api/account/schedule_info',
        data
    })
}

//获取试卷
export const work_api = data => {
    return http({
        method: "post",
        url: '/api/test/show',
        data
    })
}

//存储答题记录
export const answer_store_api = data => {
    return http({
        method: "post",
        url: '/api/test/answer_store',
        data
    })
}

//获取答题记录
export const answer_show_api = data => {
    return http({
        method: "post",
        url: '/api/test/answer_show',
        data
    })
}

//考点 获取考试项目列表
export const item_select_api = data => {
    return http({
        method: "post",
        url: '/api/place/item_select',
        data
    })
}

//考点 获取考试类别
export const test_category_select_api = data => {
    return http({
        method: "post",
        url: '/api/place/test_category_select',
        data
    })
}

//获取考试记录
export const getTest_api = data => {
    return http({
        method: "post",
        url: '/api/student/test',
        data
    })
}


//考点文件上传
export const sendMsg_api = data => {
    return http({
        method: "post",
        url: '/api/place/file_upload',
        data
    })
}

//获取当前时间
export const getTime_api = data => {
    return http({
        method: "post",
        url: '/api/get_cur_time',
        data
    })
}

//文件上传 - 校验MD5
export const checkMD5_api = data => {
    return http({
        method: "post",
        url: '/api/slice/check',
        data
    })
}

//文件上传 - 上传文件
export const upload_api = data => {
    return http({
        method: "post",
        url: '/api/slice/upload',
        data
    })
}

//文件上传 - 通知完成
export const finish_api = data => {
    return http({
        method: "post",
        url: '/api/slice/finish',
        data
    })
}


//考试结束信息
export const end_info_api = data => {
    return http({
        method: "post",
        url: '/api/account/end_info',
        data
    })
}

//获取仿真答题进度
export const u3d_progress_api = data => {
    return http({
        method: "post",
        url: '/api/test/u3d_progress',
        data
    })
}


//重新考试
export const afresh_api = data => {
    return http({
        method: "post",
        url: '/api/test/afresh',
        data
    })
}

//获取oss配置信息
export const get_oss_setting_api = data => {
  return http({
    method: "post",
    url: '/api/ali/getOssSetting',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/api.js